import { useState } from 'react';
import { LogOut, ShieldAlert } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import { endImpersonationSession } from '@/lib/impersonation';

function formatTime(date?: Date): string {
  if (!date) {
    return '';
  }

  return new Intl.DateTimeFormat('ja-JP', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function ImpersonationBanner() {
  const impersonation = useAuthStore((state) => state.impersonation);
  const signOut = useAuthStore((state) => state.signOut);
  const [isEnding, setIsEnding] = useState(false);

  if (!impersonation) {
    return null;
  }

  const handleEnd = async () => {
    try {
      setIsEnding(true);
      await endImpersonationSession(impersonation.sessionId);
    } catch (error) {
      console.error('Failed to end impersonation session:', error);
    } finally {
      await signOut();
      window.location.href = import.meta.env.VITE_ADMIN_URL || 'https://admin.kulum.jp';
    }
  };

  return (
    <div className="border-b border-amber-200 bg-amber-50 px-4 py-3 text-amber-900">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2">
          <ShieldAlert className="h-5 w-5 flex-shrink-0" />
          <p className="min-w-0 text-xs font-semibold sm:text-sm">
            代理操作中
            {impersonation.adminEmail ? ` (${impersonation.adminEmail})` : ''}
            {impersonation.expiresAt ? ` / ${formatTime(impersonation.expiresAt)}まで` : ''}
          </p>
        </div>
        <button
          type="button"
          onClick={() => void handleEnd()}
          disabled={isEnding}
          className="inline-flex flex-shrink-0 items-center gap-1 rounded-full border border-amber-300 bg-white px-3 py-1.5 text-xs font-semibold text-amber-900 disabled:opacity-60"
        >
          <LogOut className="h-4 w-4" />
          終了
        </button>
      </div>
    </div>
  );
}
